<template>
  <div class="modal" :class="{ 'modal--fullscreen': isFullscreen }">
    <div @click="onClose" class="modal-bg"></div>
    <div class="modal-box">
      <div v-if="!isFullscreen" class="modal-header">
        <div class="modal-container">
          <slot name="header-all">
            <button
              @click="onClose"
              type="button"
              class="btn btn-close flex-c-c"
            >
              <svg
                width="16"
                height="28"
                viewBox="0 0 16 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.5 1.72791L2 14.2279L14.5 26.7279"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
            </button>
          </slot>
          <slot name="header" />
        </div>
      </div>
      <div class="modal-container">
        <slot name="content" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, onBeforeUnmount, onActivated, onDeactivated } from 'vue'

const props = defineProps({
  doUnmounted: {
    type: Boolean,
    default: true,
  },
  isFullscreen: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['close'])

const beforeOpen = () => {
  document.body.style.overflow = 'hidden'
  document.addEventListener('keydown', keyDownClose)
}

const beforeClose = () => {
  if (props.doUnmounted) document.body.style.overflow = 'auto'
  document.removeEventListener('keydown', keyDownClose)
}

const onClose = () => {
  emit('close')
}

const keyDownClose = (event) => {
  if (event.code === 'Escape') onClose()
}

onMounted(beforeOpen)
onActivated(beforeOpen)

onDeactivated(beforeClose)
onBeforeUnmount(beforeClose)
</script>

<script>
export default {
  name: 'Modal',
}
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 10;
  display: flex;
  align-items: start;
  justify-content: center;
  @include mobile {
    align-items: end;
  }

  &--fullscreen {
    .modal-container {
      padding: 0;
    }
  }

  &:deep() {
    .form {
      min-height: 240px; // для того что бы было место для раскрывающегося селекта
    }
  }

  &-container {
    padding: 24px;
    @include mobile {
      padding: 16px;
    }
  }
  &-header {
    border-bottom: 1px solid #d2d2d2;
    position: relative;
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 10;
  }

  &-bg {
    background: hsla(0, 0%, 0%, 0.15);
    opacity: 1;
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: -1;
    transition: all 0.3s;
  }
  &-box {
    @include scrollbar;
    overflow-x: hidden;
    max-width: 760px;
    max-height: calc(100% - 40px - 20px);
    background: white;
    border-radius: 20px;
    width: 100%;
    margin: 40px 0 20px;
    @include mobile {
      border-radius: 20px 20px 0 0;
      max-height: calc(100% - 20px);
      margin: 0;
    }
  }
}
</style>
